import script from "./VipBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./VipBadge.vue?vue&type=script&lang=ts&setup=true"

import "./VipBadge.vue?vue&type=style&index=0&id=075cec20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075cec20"]])

export default __exports__